import { Switch } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/outline";
import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { classNames } from "../../helpers";
import { useAuth } from "../../context/AuthContext";
import RequestResignation from "../modal/RequestResignation";
import { ApiResponse } from "../../api/apiResponse";
import { ToastContext } from "../../App";
import { updateTutor } from "../../api/endpoints/tutors/tutors";

export default function SettingSection() {
  const LocalBasePath = "page.settings";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { currentUser }: any = useAuth();
  const [enabled, setEnabled] = useState(currentUser?.isAvailable);
  const [open, setOpen] = useState(false);
  const toast = useContext(ToastContext);
  const saveData = async (status: any) => {
    console.log(status);
    let apiData: any = {
      is_available: status,
    };

    const response: ApiResponse = await updateTutor(apiData);
    if (response.isSuccess) {
      toast?.success("savedSuccessfully");
      window.location.reload();
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast?.error(errorMessage);
      });
    }
  };
  return (
    <>
      <div className="w-full py-2">
        <h3 className="w-full  text-gray-900 font-medium text-lg leading-6 ">
          {t("settings")}
        </h3>
      </div>
      <div className="w-full">
        <ul role="list">
          <li className="border-b border-gray-200">
            <div className="flex gap-2  md:gap-0 md:items-center  flex-col md:flex-row py-4">
              <div className="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <div className="flex w-full flex-wrap">
                    <p className="flex w-full flex-wrap font-medium text-sm text-gray-700">
                      {t("availableToReceive")}
                    </p>
                  </div>
                  <div className="mt-1 w-full flex  flex-wrap">
                    <p className=" flex w-full flex-wrap text-xs leading-5 flex-shrink-0 font-normal text-gray-500">
                      {t("subAvailableToReceiver")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="flex p-1 justify-end  -space-x-1 overflow-hidden">
                  <Switch
                    checked={enabled}
                    onChange={(e: any) => {
                      saveData(!enabled);
                      setEnabled((prev: boolean) => !prev);
                    }}
                    className={classNames(
                      enabled ? "bg-brandblue-600" : "bg-gray-200",
                      "relative inline-flex h-6 w-11 z-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
                    )}
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        enabled
                          ? "rtl:-translate-x-5 ltr:translate-x-5"
                          : "translate-x-0",
                        "pointer-events-none inline-block h-5 w-5  z-50 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                      )}
                    />
                  </Switch>
                </div>
              </div>
            </div>
          </li>
          <li className="border-b border-gray-200">
            <div className="flex items-center py-4">
              <div className="min-w-0 flex-1 md:flex md:items-center sm:justify-between">
                <div className=" flex w-full flex-wrap">
                  <div className="flex text-sm">
                    <p className="flex w-full flex-wrap font-medium text-sm text-gray-700">
                      {t("resignation")}
                    </p>
                  </div>
                  <div className="mt-1 w-full flex  flex-wrap">
                    <p className=" flex w-full flex-wrap text-xs leading-5 flex-shrink-0 font-normal text-gray-500">
                      {t("subResignation")}
                    </p>
                  </div>
                </div>
                <div className="flex-shrink-0 flex justify-end  sm:ml-5">
                  <div className="flex -space-x-1 overflow-hidden">
                    <button
                      onClick={() => setOpen(true)}
                      className="text-red-600 p-1 md:p-0 flex items-center gap-2 font-medium text-sm border-none"
                    >
                      {t("request")}
                      <ChevronRightIcon
                        className="h-5 w-5  block md:hidden rtl:rotate-180 text-red-600"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 ltr:ml-2">
                <ChevronRightIcon
                  className="h-5 w-5 hidden md:block rtl:rotate-180 text-red-600"
                  aria-hidden="true"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="w-full my-4">
        <p className="flex items-start justify-end w-full  font-normal text-xs leading-5  text-gray-500  ">
          {t("createdAt", {
            date: currentUser.created_at.format("DD/MM/YYYY hh:mm A"),
          })}
        </p>
      </div>
      <RequestResignation open={open} setOpen={() => setOpen(false)} />
    </>
  );
}
